<div class="container-fluid">
     <div class="row">
          <div class="col-md-12 mb-3">
               <div class="breadcrumb-title mt-3 mt-md-0">
        <app-list-header
          [title]="'REPORTS.TITLE' | translate"
          icon="bi bi-clipboard2-data"
          [$parent]="getSelf()"
        >
                    </app-list-header>
               </div>
          </div>
     </div>
     <div class="row">
    <div class="pt-3 mt-1 mb-3 card card-show">
               <div class="row">
                    <div class="col-xl-4 col-12 mb-3 px-2" *ngIf="!reportIdFromUrl">
                         <div class="card h-100">
            <div class="card-header">
              <div
                class="d-flex align-items-center justify-content-between flex-wrap"
              >
                                        <h6>
                  {{ "REPORTS.REPORT_LIST" | translate }}
                                        </h6>
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="showSearch()"
                  [matTooltip]="'REPORTS.SEARCH_REPORTS' | translate"
                  class="icon-width"
                  matTooltipPosition="above"
                  aria-label=" Search Reports"
                >
                                             <mat-icon>tune</mat-icon>
                  <span class="ms-2">{{
                    "APP_STORE.SEARCH.FILTER" | translate
                  }}</span>
                                        </button>
                                   </div>

              <div
                class="row mt-3 compact-inputs dropdown-pd-none"
                *ngIf="show"
              >
                                        <div class="col-12 mb-2">
                                             <div class="d-flex">
                    <mat-form-field
                      appearance="outline"
                      subsriptSizing="dynamic"
                      class="mb-1 flex-grow-1"
                    >
                      <mat-label>{{
                        "REPORTS.SEARCH_PLACEHOLDER" | translate
                                                            }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="form.searchParams['title']"
                        name="title"
                        id="title"
                      />
                                                  </mat-form-field>
                                             </div>
                                        </div>
                                        <div class="col-12 mb-2">
                                             <div class="d-flex">
                    <mat-form-field
                      appearance="outline"
                      subsriptSizing="dynamic"
                      class="mb-1 flex-grow-1"
                    >
                      <mat-label>{{
                        "REPORTS.SELECT_APPLICATION" | translate
                                                            }}</mat-label>
                      <mat-select
                        [(ngModel)]="form.searchParams['applicationId']"
                                                            name="applicationName"
                        (selectionChange)="onApplicationChange($event)"
                      >
                                                            <mat-option [value]="undefined">
                          {{ "REPORTS.SELECT_APPLICATION" | translate }}
                                                            </mat-option>
                                                            <mat-option
                          *ngFor="
                            let e of form.preload?.['cuickdev.application']
                          "
                          [value]="e['id']"
                        >
                          {{ e["_val"] }}
                                                            </mat-option>
                                                       </mat-select>
                                                  </mat-form-field>
                                             </div>
                                        </div>
                                        <div class="col-12  mb-2">
                                             <div class="d-flex">
                    <mat-form-field
                      appearance="outline"
                      subsriptSizing="dynamic"
                      class="mb-1 flex-grow-1"
                    >
                      <mat-label>{{
                        "REPORTS.SELECT_FORM" | translate
                      }}</mat-label>
                      <mat-select
                        [(ngModel)]="form.searchParams['uiFormId']"
                        name="uiFormId"
                      >
                                                            <mat-option [value]="undefined">
                          {{ "REPORTS.SELECT_FORM" | translate }}
                                                            </mat-option>
                                                            <mat-option *ngFor="let e of forms" [value]="+e['id']">
                          {{ e["title"] }}
                                                            </mat-option>
                                                       </mat-select>
                                                  </mat-form-field>
                                             </div>
                                        </div>

                                        <div class="col-auto pe-1 mb-2">
                  <button
                    mat-stroked-button
                    color="primary"
                                                  [matTooltip]="'COMMON.SEARCH' | translate"
                    class="icon-width icon-center"
                    (click)="search()"
                  >
                                                  <mat-icon>search</mat-icon>
                    <span>{{ "APP_STORE.SEARCH.Search" | translate }}</span>
                                             </button>
                                        </div>
                                        <div class="col-auto ps-1 mb-2">
                  <button
                    mat-stroked-button
                    color="primary"
                    (click)="resetSearchForm()"
                                                  class="icon-width icon-center"
                    [matTooltip]="'COMMON.RESET' | translate"
                  >
                                                  <i class="fa fa-eraser" aria-hidden="true"></i>
                    <span class="ms-2">{{
                      "AI_Assistant.Clear" | translate
                    }}</span>
                                             </button>
                                        </div>
                                   </div>
                              </div>
                              <div class="card-body p-0">
                                   <div class="p-2">
                                        <p *ngIf="form['error'] == false && form['message']">
                                             <app-ncs-alert [message]="form['message']" type="success" />
                                        </p>
                                        <p *ngIf="form['error'] == true && form['message']">
                                             <app-ncs-alert [message]="form['message']" type="danger" />
                                        </p>

                <p
                  *ngIf="form['searchError'] == false && form['searchMessage']"
                >
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="success"
                  />
                                        </p>
                                        <p *ngIf="form['searchError'] == true && form['searchMessage']">
                  <app-ncs-alert
                    [message]="form['searchMessage']"
                    type="danger"
                  />
                                        </p>
                                   </div>

                                   <div class="table-responsive px-1 pb-2">
                <div
                  class="list-group st"
                  style="height: calc(100% - 50px); overflow: auto"
                >
                  <div
                    *ngFor="let e of form.list; let i = index"
                    class="list-group-item d-flex justify-content-between"
                  >
                                                  <div class="flex-grow-1 text-start">
                      <a
                        href="javascript:void(0)"
                        (click)="setDetails(e)"
                        class="text-decoration-none"
                      >
                                                            <span>{{ pageIndex(i) }}.</span>
                                                            <span [title]="e['title']">
                          {{ transform(e["title"], 15) }} <br />

                          <small
                            class="text-muted d-block"
                            [title]="e['applicationName']"
                          >
                            <span class="fw-bold"
                              >{{ "REPORTS.APP_LABEL" | translate }}:</span
                            >
                            {{ transform(e["applicationName"], 15) }}
                                                                 </small>

                          <small
                            class="text-muted d-block"
                            [title]="e['formTitle']"
                          >
                            <span class="fw-bold"
                              >{{ "REPORTS.FORM_LABEL" | translate }}:</span
                            >
                            {{ transform(e["formTitle"], 15) }}
                                                                 </small>
                                                            </span>
                                                       </a>
                                                  </div>

                                                  <div class="d-flex align-items-center">
                      <button
                        mat-stroked-button
                        color="primary"
                                                            class="icon-width icon-center me-2 icon-pd-none"
                                                            [matTooltip]="'REPORTS.ADD_DATA' | translate"
                        [routerLink]="'/uiformpivot/' + e.uiFormId"
                      >
                                                            <mat-icon class="icon-compact">add</mat-icon>
                                                       </button>

                      <button
                        mat-stroked-button
                                                       class="icon-width icon-center me-2 icon-pd-none"
                        [color]="
                          e.addOnDashboardReport == 1 ? 'primary' : 'primary'
                        "
                        [matTooltip]="
                          e.addOnDashboardReport == 1
                            ? ('ALLREMAININGS.REMOVE_FROM_DASHBOARD'
                              | translate)
                            : ('ALLREMAININGS.ADD_TO_DASHBOARD' | translate)
                        "
                                                       matTooltipPosition="above"
                        (click)="toggleDashboard(e)"
                      >
                                                       <mat-icon class="icon-compact">
                          {{
                            e.addOnDashboardReport == 1 ? "close" : "dashboard"
                          }}
                                                       </mat-icon>
                                                       </button>

                      <button
                        mat-stroked-button
                        color="warn"
                                                            class="icon-width icon-center icon-pd-none"
                                                            [matTooltip]="'COMMON.DELETE' | translate"
                        (click)="delete(e.id)"
                      >
                                                            <mat-icon class="icon-compact">delete</mat-icon>
                                                       </button>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>

        <div
          [ngClass]="reportIdFromUrl ? 'col-12' : 'col-xl-8 col-12'"
          class="mb-3 px-2"
        >
          <app-view-report
            *ngIf="componentFlag"
            [flag]="true"
            [searchdata]="searchdata"
            [titlereport]="titlereport"
            [uiformid]="uiFormId"
            [searchList]="searchList"
            [uiFormData]="uiFormData"
            [autoUpdateReport]="autoUpdateReport"
            [reportId]="reportId"
          >
                         </app-view-report>
                    </div>
               </div>
    </div>
     </div>
</div>